import {useMutation} from "@tanstack/react-query";
import {addExpedientNoteMutationOptions} from "./add-expedient-note.mutation-options";

export function useAddExpedientNote(id: string) {
  return useMutation(addExpedientNoteMutationOptions(id));
}
